import { render, staticRenderFns } from "./BoardView.vue?vue&type=template&id=04bf8f34&scoped=true&"
import script from "./BoardView.vue?vue&type=script&lang=js&"
export * from "./BoardView.vue?vue&type=script&lang=js&"
import style0 from "./BoardView.vue?vue&type=style&index=0&id=04bf8f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf8f34",
  null
  
)

export default component.exports